import MiBackToTopBtn from './MiBackToTopBtn.vue'

export default MiBackToTopBtn
